
/*!
 * Bubble Slider
 * https://github.com/dahjson/bubble-slider
 * Copyright (c) Daniel Johnson
 */
(function($) {
  var BubbleSlider;
  BubbleSlider = (function() {
    function BubbleSlider(element, options) {
      var bubbleHeight, ref, ref1, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, trackHeight;
      this.element = element;
      this.element.hide();
      this.min = (ref = this.element.attr('min')) != null ? ref : options.min;
      this.max = (ref1 = this.element.attr('max')) != null ? ref1 : options.max;
      this.step = (ref2 = this.element.attr('step')) != null ? ref2 : options.step;
      this.value = (ref3 = this.element.attr('value')) != null ? ref3 : (options.max - options.min) / 2 + options.min;
      this.decimals = (ref4 = this.element.data('decimals')) != null ? ref4 : options.decimals;
      this.prefix = (ref5 = this.element.data('prefix')) != null ? ref5 : options.prefix;
      this.postfix = (ref6 = this.element.data('postfix')) != null ? ref6 : options.postfix;
      this.toggleBubble = (ref7 = this.element.data('toggle-bubble')) != null ? ref7 : options.toggleBubble;
      this.toggleLimit = (ref8 = this.element.data('toggle-limit')) != null ? ref8 : options.toggleLimit;
      this.bubbleColor = (ref9 = this.element.data('bubble-color')) != null ? ref9 : options.bubbleColor;
      this.bubbleFontScale = (ref10 = this.element.data('bubble-font-scale')) != null ? ref10 : options.bubbleFontScale;
      this.bubbleFontColor = (ref11 = this.element.data('bubble-font-color')) != null ? ref11 : options.bubbleFontColor;
      this.thumbScale = (ref12 = this.element.data('thumb-scale')) != null ? ref12 : options.thumbScale;
      this.thumbColor = (ref13 = this.element.data('thumb-color')) != null ? ref13 : options.thumbColor;
      this.thumbFontScale = (ref14 = this.element.data('thumb-font-scale')) != null ? ref14 : options.thumbFontScale;
      this.thumbFontColor = (ref15 = this.element.data('thumb-font-color')) != null ? ref15 : options.thumbFontColor;
      this.trackScale = (ref16 = this.element.data('track-scale')) != null ? ref16 : options.trackScale;
      this.trackColor = (ref17 = this.element.data('track-color')) != null ? ref17 : options.trackColor;
      this.min = parseFloat(this.removeCommas(this.min));
      this.max = parseFloat(this.removeCommas(this.max));
      this.step = parseFloat(this.removeCommas(this.step));
      this.value = parseFloat(this.removeCommas(this.value));
      this.decimals = parseFloat(this.removeCommas(this.decimals));
      this.toggleLimit = parseFloat(this.removeCommas(this.toggleLimit));
      this.bubbleFontScale = parseFloat(this.removeCommas(this.bubbleFontScale));
      this.thumbScale = parseFloat(this.removeCommas(this.thumbScale));
      this.thumbFontScale = parseFloat(this.removeCommas(this.thumbFontScale));
      this.trackScale = parseFloat(this.removeCommas(this.trackScale));
      this.slider = $('<div>').addClass('bubble-slider-wrap').insertAfter(this.element);
      this.minus = $('<div><span>-</span></div>').addClass('bubble-slider-minus').appendTo(this.slider);
      this.plus = $('<div><span>+</span></div>').addClass('bubble-slider-plus').appendTo(this.slider);
      this.track = $('<div>').addClass('bubble-slider-track').appendTo(this.slider);
      this.thumb = $('<div><span>').addClass('bubble-slider-thumb').appendTo(this.track);
      this.bubble = $('<div><span>').addClass('bubble-slider-bubble').appendTo(this.thumb);
      this.bubbleArrow = $('<div>').addClass('bubble-slider-bubble-arrow').prependTo(this.bubble);
      this.thumbSpan = this.thumb.find('span').first();
      this.bubbleSpan = this.bubble.find('span').first();
      if (this.bubbleFontScale !== 1) {
        this.bubble.css({
          'font-size': parseFloat(this.bubble.css('font-size')) * this.bubbleFontScale + 'px',
          'border-radius': parseFloat(this.bubble.css('border-radius')) * this.bubbleFontScale + 'px'
        });
        this.bubbleArrow.css({
          'width': parseFloat(this.bubbleArrow.css('width')) * this.bubbleFontScale + 'px',
          'height': parseFloat(this.bubbleArrow.css('height')) * this.bubbleFontScale + 'px'
        });
      }
      if (this.thumbScale !== 1) {
        this.thumb.css({
          'width': parseFloat(this.thumb.css('width')) * this.thumbScale + 'px',
          'height': parseFloat(this.thumb.css('height')) * this.thumbScale + 'px'
        });
      }
      if (this.thumbFontScale !== 1) {
        this.thumbSpan.css({
          'font-size': parseFloat(this.thumbSpan.css('font-size')) * this.thumbFontScale + 'px'
        });
      }
      if (this.trackScale !== 1) {
        this.minus.css({
          'width': Math.round(parseFloat(this.minus.css('width')) * this.trackScale) + 'px',
          'height': Math.round(parseFloat(this.minus.css('height')) * this.trackScale) + 'px',
          'font-size': Math.round(parseFloat(this.minus.css('font-size')) * this.trackScale) + 'px'
        });
        this.plus.css({
          'width': Math.round(parseFloat(this.plus.css('width')) * this.trackScale) + 'px',
          'height': Math.round(parseFloat(this.plus.css('height')) * this.trackScale) + 'px',
          'font-size': Math.round(parseFloat(this.plus.css('font-size')) * this.trackScale) + 'px'
        });
        this.track.css({
          'left': parseFloat(this.minus.outerWidth()) + (this.minus.outerWidth() * 0.2) + 'px',
          'right': parseFloat(this.plus.outerWidth()) + (this.plus.outerWidth() * 0.2) + 'px'
        });
      }
      if (this.bubbleFontScale !== 1 || this.thumbScale !== 1 || this.trackScale !== 1) {
        trackHeight = this.thumb.outerHeight() > this.plus.outerHeight() ? this.thumb.outerHeight() : this.plus.outerHeight();
        bubbleHeight = this.bubble.outerHeight();
        this.slider.css({
          'margin': parseFloat(trackHeight) + parseFloat(bubbleHeight) + 'px auto'
        });
      }
      if (this.bubbleColor) {
        this.bubbleArrow.css('background', this.bubbleColor);
        this.bubble.css('background', this.bubbleColor);
      }
      if (this.bubbleFontColor) {
        this.bubbleSpan.css('color', this.bubbleFontColor);
      }
      if (this.thumbColor) {
        this.minus.css('color', this.thumbColor);
        this.plus.css('color', this.thumbColor);
        this.thumb.css('background', this.thumbColor);
      }
      if (this.thumbFontColor) {
        this.thumbSpan.css('color', this.thumbFontColor);
      }
      if (this.trackColor) {
        this.minus.css('border-color', this.trackColor);
        this.plus.css('border-color', this.trackColor);
        this.track.css('background', this.trackColor);
      }
      this.dragging = false;
      this.thumbOffset = this.thumb.outerWidth() / 2;
      this.setValue(this.value);
      this.positionThumb(this.value);
      if (this.toggleBubble && this.value.toString().length <= this.toggleLimit) {
        this.bubble.hide();
        this.thumbSpan.show();
      } else {
        this.thumbSpan.hide();
      }
      this.thumb.css('-ms-touch-action', 'none');
      this.thumb.on('mousedown touchstart', (function(_this) {
        return function(event) {
          if (!_this.dragging) {
            event.preventDefault();
            _this.dragging = true;
            return _this.bubbleState(true);
          }
        };
      })(this));
      $('html').on('mousemove touchmove', (function(_this) {
        return function(event) {
          if (_this.dragging) {
            event.preventDefault();
            if (event.type === 'touchmove') {
              return _this.dragThumb(event.originalEvent.touches[0].pageX);
            } else {
              return _this.dragThumb(event.originalEvent.pageX);
            }
          }
        };
      })(this)).on('mouseup touchend', (function(_this) {
        return function(event) {
          if (_this.dragging) {
            event.preventDefault();
            _this.dragging = false;
            return _this.bubbleState(false);
          }
        };
      })(this));
      this.minus.on('click', (function(_this) {
        return function(event) {
          var newValue;
          event.preventDefault();
          newValue = _this.value - _this.step;
          newValue = Math.max(_this.min, newValue);
          _this.setValue(newValue);
          return _this.positionThumb(newValue);
        };
      })(this));
      this.plus.on('click', (function(_this) {
        return function(event) {
          var newValue;
          event.preventDefault();
          newValue = _this.value + _this.step;
          newValue = Math.min(_this.max, newValue);
          _this.setValue(newValue);
          return _this.positionThumb(newValue);
        };
      })(this));
      $(window).on('resize onorientationchange', (function(_this) {
        return function() {
          return _this.positionThumb(_this.value);
        };
      })(this));
    }

    BubbleSlider.prototype.dragThumb = function(pageX) {
      var maxPosition, minPosition, newPosition;
      minPosition = this.track.offset().left + this.thumbOffset;
      maxPosition = this.track.offset().left + this.track.innerWidth() - this.thumbOffset;
      newPosition = Math.max(minPosition, pageX);
      newPosition = Math.min(maxPosition, newPosition);
      this.setValue(this.calcValue());
      return this.thumb.offset({
        left: newPosition - this.thumbOffset
      });
    };

    BubbleSlider.prototype.calcValue = function() {
      var trackRatio;
      trackRatio = this.normalize(this.thumb.position().left, 0, this.track.innerWidth() - this.thumbOffset * 2);
      return trackRatio * (this.max - this.min) + this.min;
    };

    BubbleSlider.prototype.setValue = function(value) {
      var modValue;
      this.value = Math.round((value - this.min) / this.step) * this.step + this.min;
      this.element.val(this.value);
      modValue = this.prefix + this.addCommas(this.value.toFixed(this.decimals)) + this.postfix;
      this.thumbSpan.text(modValue);
      return this.bubbleSpan.text(modValue);
    };

    BubbleSlider.prototype.positionThumb = function(value) {
      var thumbRatio;
      thumbRatio = this.normalize(value, this.min, this.max);
      return this.thumb.offset({
        left: Math.round(thumbRatio * (this.track.innerWidth() - this.thumbOffset * 2) + this.track.offset().left)
      });
    };

    BubbleSlider.prototype.bubbleState = function(state) {
      if (this.toggleBubble) {
        if (state) {
          this.bubble.stop(true, true).fadeIn(300);
          return this.thumbSpan.stop(true, true).fadeOut(200);
        } else if (this.value.toString().length <= this.toggleLimit) {
          this.bubble.stop(true, true).fadeOut(300);
          return this.thumbSpan.stop(true, true).fadeIn(200);
        }
      }
    };

    BubbleSlider.prototype.normalize = function(number, min, max) {
      return (number - min) / (max - min);
    };

    BubbleSlider.prototype.addCommas = function(num) {
      return num.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    };

    BubbleSlider.prototype.removeCommas = function(num) {
      return num.toString().replace(/,/g, '');
    };

    return BubbleSlider;

  })();
  $.fn.bubbleSlider = function(options) {
    var defaults, settings;
    defaults = {
      min: 0,
      max: 100,
      step: 1,
      value: 50,
      decimals: 0,
      prefix: '',
      postfix: '',
      toggleBubble: false,
      toggleLimit: 3,
      bubbleColor: '',
      bubbleFontScale: 1,
      bubbleFontColor: '',
      thumbScale: 1,
      thumbColor: '',
      thumbFontScale: 1,
      thumbFontColor: '',
      trackScale: 1,
      trackColor: ''
    };
    settings = $.extend({}, defaults, $.fn.bubbleSlider.defaults, options);
    return new BubbleSlider($(this), settings);
  };
  return $(function() {
    return $('.bubble-slider').each(function() {
      return $(this).bubbleSlider();
    });
  });
})(this.jQuery);
